import {
  Component,
  OnInit,
  ViewEncapsulation,
  ViewChild
} from "@angular/core";
import { fuseAnimations } from "../../../../../../../../../../core/animations";
import * as _ from "lodash";
import { MatTableDataSource, MatPaginator, MatSort, MatDialogRef, MatDialog } from "@angular/material";
import { Observable } from "rxjs";
import { Subscription } from 'rxjs/Subscription';

// Local component
import { ToastComponent } from "../../../../../../../common/toast.component";
import { FuseConfirmDialogComponent } from "../../../../../../../../../../core/components/confirm-dialog/confirm-dialog.component";
import { EditSolutionComponent } from "../edit-solution-description/edit-solution.component";

// Model & Util
import { SolutionDescriptionNodes, FetchAllSolutionDescription } from "../../../../../../../models/index";
import { displayValues, paginationArray, toastMsg } from "../../../../../../../utils/index";

//Services
import { SideNavService } from "../../../../sidenav.service";
import { environment } from "../../../../../../../../../../../environments/environment";
import { AuditHistoryService } from "../../../../../../../../../../core/services/audit-history.service";

@Component({
  selector: "spekwo-solution-description-list",
  templateUrl: "./solution-list.component.html",
  styleUrls: ["./solution-list.component.scss"],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class SolutionListComponent implements OnInit {

  displayValues = displayValues;
  allSolutionDescriptions: SolutionDescriptionNodes[] = [];

  isAllDataFetched: boolean = false;
  tableLoader: boolean = false;

  displayedColumns = [
    'keyPrimCategory',
    'subCategory',
    'kw1',
    'kw2',
    'kw3',
    'kw4',
    'solution',
    'costoption',
    'totalCost',
    'links',
    'buttons'
  ];
  newParams;
  confirmDialogRef: MatDialogRef<FuseConfirmDialogComponent>;
  isSolutionsUpdated: Observable<boolean>;
  toastMsg = toastMsg;

  private _subscription: Subscription;
  private _subscriptions: Subscription[] = [];

  dialogRef: any;

  isLoadingResults = false;
  isRateLimitReached = false;
  endCursor: string;
  hasNextPage: boolean = false

  solutiondataSource: MatTableDataSource<SolutionDescriptionNodes>;

  onSolutionsChangedSubscription: Subscription;
  finalSolutionsRequestChangedSubscription: Subscription;

  currentPageIndex: number = 0;
  pageSize: number = 5; //Initially load 5 by 5 per page
  from: string;
  private orderCount: number = 0;
  selectedId: any;

  public userId: any;
  public roleId: any;
  isHighLevelPermission: boolean;

  paginator = paginationArray;

  @ViewChild("contactPaginator") contactPaginator: MatPaginator;
  @ViewChild(MatSort) contactSort: MatSort;

  constructor(
    private _sideNavService: SideNavService,
    private _toastComponent: ToastComponent,
    public dialog: MatDialog,
    public auditHistoryService: AuditHistoryService,

  ) {
    this.userId = window.localStorage.getItem('userUID');
    this.roleId = window.localStorage.getItem('roleId');
    this.isHighLevelPermission = environment.ownerRoleId === this.roleId || environment.executiveRoleId === this.roleId;
    this.isSolutionsUpdated = this._sideNavService.onSolutionInfo.asObservable();
  }

  // TODO: For all params - Add model
  ngOnInit() {
    //Subscription to watch any changes happen in table data(add,edit,delete)
    this._subscriptions.push(
      this.isSolutionsUpdated.subscribe((event) => {
        if (event) {
          this.getallSolutionDescriptions();
        }
      })
    );
    this.isAllDataFetched = false;
    //to fecth table data by limit
    this._subscriptions.push(
      this._sideNavService.onSolutionDatabaseChanged.subscribe(response => {
        this.endCursor = '';
        this.hasNextPage = false;

        // Not to show loader while fetching next set of solution list
        this.tableLoader = this.allSolutionDescriptions.length == 0 ? true : false;

        //calling Assigning function response to the local values
        this.getSolutionsByLimit(response);

      }, () => {
        this.tableLoader = false;
        this.isLoadingResults = false;
      })
    );

  }

  //Bec, initially load paginator only
  ngAfterViewInit() {
    if (this.solutiondataSource) {
      this.solutiondataSource.paginator = this.contactPaginator;
      this.solutiondataSource.sort = this.contactSort;
    }
  }


  ngOnDestroy() {
    this._subscriptions.forEach(subscriptions => subscriptions.unsubscribe());
  }

  //Calling a query funciton based on event changed
  getallSolutionDescriptions() {
    this.tableLoader = true;
    // console.log("event changed");
    this.currentPageIndex = 0;
    this.allSolutionDescriptions = [];
    this._sideNavService.fetchAllSolutionDescriptionsByLimit('initial', '');

  }

  //Assigning  response to the local values
  getSolutionsByLimit(response, event?: string) {
    if (!response.loading) {

      this.endCursor = response.endCursor;
      this.hasNextPage = response.hasNextPage;
      this.from = response.from;
      // console.log(response.solutionDescriptionList);
      //If response is initial assigning instead of concat(For Edit or delete purpose)
      if (this.from == 'initial') {
        this.allSolutionDescriptions = [];
        this.allSolutionDescriptions = response.solutionDescriptionList;//Assigned solutions
        this.isAllDataFetched = true;
      }
      else {
        this.allSolutionDescriptions = this.allSolutionDescriptions.length == 0
          ? response.solutionDescriptionList :
          this.allSolutionDescriptions.concat(response.solutionDescriptionList); //Assigned solutions
        this.isAllDataFetched = true;
      }

      //Calling filtering function
      if (response.solutionDescriptionList.length > 0 ||
        this.allSolutionDescriptions.length == 0) {
        this.loadResult();
      }
      else {
        this.tableLoader = false;
        this.isLoadingResults = false; //if nothing to fetch only set as false
        console.log('No ned to call');
      }

    } else {
      this.tableLoader = this.allSolutionDescriptions.length == 0 ? true : false;
    }
  }



  //Filter a array by unique id
  loadResult() {

    this.allSolutionDescriptions = _.uniqBy(this.allSolutionDescriptions, 'id');
    this.assignDataSource(this.allSolutionDescriptions);
  }

  //Assigning datasource values
  assignDataSource(solutions) {

    this.solutiondataSource = new MatTableDataSource(solutions);
    this.solutiondataSource.paginator = this.contactPaginator;
    this.solutiondataSource.sort = this.contactSort;
    this.orderCount = this.allSolutionDescriptions.length;
    this.tableLoader = false;

    if ((Math.ceil(this.orderCount / this.pageSize)) == this.currentPageIndex + 1) {  //Check page laste page of total solutions
      // case : some case 25 item load - 76 of 100 in 100 - data load next data
      this.callNextSetOfSolutions(); //If so , call next set of data
    } else {
      this.isLoadingResults = false; //if nothing to fetch only set as false
    }
  }

  //To get current page index
  onPaginateChange(event) {
    // console.log('event', event);

    this.currentPageIndex = event.pageIndex; //Index on total page ( 0,1,2,3...)
    this.pageSize = event.pageSize; //Data per page (5,10,15 ....)
    // this.pageLength = event.length;  //Page length (10,20 ....)

    // Check data reach end of data
    this.callNextSetOfSolutions();
  }

  //Calling query to fetch next set of solutions
  callNextSetOfSolutions() {

    if (this.hasNextPage) {

      // Check data reach end of data
      if ((Math.ceil(this.orderCount / this.pageSize)) == this.currentPageIndex + 1) {

        this.orderCount = this.allSolutionDescriptions.length; //It should get all orders count

        this.isLoadingResults = true;
        //When it reach end of data it should get next set of data
        this._sideNavService.fetchAllSolutionDescriptionsByLimit('', this.endCursor);

      } else {
        this.orderCount = this.orderCount == 0 ? this.allSolutionDescriptions.length : this.orderCount;
      }
    } else {
      console.log('reached end');
    }

  }

  /** Based on row select- Highlight row */
  onSelect(selected) {
    this.selectedId = selected.id;
  }


  //Edit functionality
  editContact(solution: SolutionDescriptionNodes) {
    //Calling Edit Dialog
    this.dialogRef = this.dialog.open(EditSolutionComponent, {
      width: '100%',
      height: 'auto',
      panelClass: 'solution-form-dialogs',
      data: {
        solution: solution,
      }
    });

    //Getting response from edit component
    this.dialogRef.afterClosed()
      .subscribe(response => {
        if (!response) {
          return;
        }
        const updatedSolution: SolutionDescriptionNodes = response[0]
        const status: string = response[1];

        if (status == 'success') {

          //Finding index of selected row
          var index = this.allSolutionDescriptions.findIndex(function (solutiondesc) {
            return solutiondesc.id == solution.id
          });

          //Update array with updated row values
          this.allSolutionDescriptions[index] = Object.assign({}, updatedSolution);

          //Re assigning table data
          this.assignDataSource(this.allSolutionDescriptions);

        }
        if (updatedSolution.keyPrimCategory) {
          // primary category store in Db 
          this._sideNavService.getAllCategories().then(
            (response: any) => {
              if (response && response.data && response.data.allWccategories && response.data.allWccategories.nodes) {
                let check = _.filter(response.data.allWccategories.nodes, event =>
                  event.category.trim() === updatedSolution.keyPrimCategory.toUpperCase().trim()
                );
                if (check.length === 0) {
                  this._sideNavService.createPrimaryCategory(updatedSolution.keyPrimCategory).then((response: any) => {
                    if (response && response.data && response.data.createWccategory && response.data.createWccategory.wccategoryEdge && response.data.createWccategory.wccategoryEdge.node) {
                      let categoryId = response.data.createWccategory.wccategoryEdge.node.categoryid;
                      this.createSubCategory(categoryId, updatedSolution.subcategory);
                    }
                  }).catch((err) => {
                    console.log(err);
                  });
                }
                else {
                  console.log("primary category already present");
                  this.createSubCategory(check[0].categoryid, updatedSolution.subcategory)
                }
              }


            }).catch((err) => {
              console.log(err);
            });
        }
      });


  }
  createSubCategory(categoryId, subcategoryvalue) {
    if (subcategoryvalue) {
      this._sideNavService.getAllSubCategories(categoryId).then((response: any) => {

        if (response.data.allWcsubcategories.nodes.length === 0) {
          this._sideNavService.createSubCategory(categoryId, subcategoryvalue).then((response: any) => {
          }).catch((err) => {
            console.log(err);
          });
        }
        if (response && response.data && response.data.allWcsubcategories && response.data.allWcsubcategories.nodes && response.data.allWcsubcategories.nodes.length > 0) {
          let check = _.filter(response.data.allWcsubcategories.nodes, event =>
            event.subcategory.toUpperCase().trim() === subcategoryvalue.toUpperCase().trim()
          );

          if (check.length === 0) {
            this._sideNavService.createSubCategory(categoryId, subcategoryvalue).then((response: any) => {

            }).catch((err) => {
              console.log(err);
            });
          }
          else {
            console.log("subcategory already present ");
          }
        }


      }).catch((err) => {
        console.log(err);
      });
    }
  }

  //Delete functionalityyp
  deleteContact(solutionId: number, solution: SolutionDescriptionNodes) {
    this.newParams = solution;
    this.confirmDialogRef = this.dialog.open(FuseConfirmDialogComponent, {
      disableClose: false
    });

    this.confirmDialogRef.componentInstance.confirmMessage = this.displayValues.manageRef.deleteConfirm;
    this.confirmDialogRef.componentInstance.confirmHead = this.displayValues.manageRef.deleteHead;
    this.confirmDialogRef.componentInstance.confirmOkText = this.displayValues.manageRef.deleteOk;
    this.confirmDialogRef.componentInstance.confirmCancelText = this.displayValues.manageRef.deleteCancel;

    this.confirmDialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.tableLoader = true;
        this._sideNavService.
          deleteSolutionDescriptionByIdOnDb(solutionId).then((res) => {
            if (res) {
              this.auditHistoryFunCall(displayValues.success)
              this._toastComponent.showToast(this.toastMsg.deleteScheSuccess);
              this.allSolutionDescriptions = _.pull(this.allSolutionDescriptions, solution);
              this.assignDataSource(this.allSolutionDescriptions);
            }
          }, () => {
            this.auditHistoryFunCall(displayValues.failed)
            this._toastComponent.showToast(this.toastMsg.deleteScheFailed);
          }).catch((err) => {
            console.log(err);
          });
      }
      this.confirmDialogRef = null;
    });

  }

  auditHistoryFunCall(status) {

    let newParams = {
      "solution": this.newParams && this.newParams.solution ? this.newParams.solution : null,
      "keyPrimCategory": this.newParams && this.newParams.keyPrimCategory ? this.newParams.keyPrimCategory : null,
      "subcategory": this.newParams && this.newParams.subcategory ? this.newParams.subcategory : null,
      "key1": this.newParams && this.newParams.key1 ? this.newParams.key1 : null,
      "key2": this.newParams && this.newParams.key2 ? this.newParams.key2 : null,
      "key3": this.newParams && this.newParams.key3 ? this.newParams.key3 : null,
      "key4": this.newParams && this.newParams.key4 ? this.newParams.key4 : null,
      "costOption": this.newParams && this.newParams.costOption ? this.newParams.costOption : null,
      "totalCost": this.newParams && this.newParams.totalCost ? this.newParams.totalCost : null,
    };


    let auditLogPayload = {
      roleId: window.localStorage.getItem('roleId'),
      userId: window.localStorage.getItem('userUID'),
      orderId: null,
      newData: newParams,
      oldData: null,
      auditType: "delete_se_into_db",
      logsDesc: "Solution was deleted to the database ",
      platform: "Executive Dashboard",
      status: status,
      createdAt: "now()"

    };
    this.auditHistoryService.auditHistoryForCreateOrDeleteCall(auditLogPayload);
  }

}




// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/sidenavs/left/operations/solution-description/solution-list/solution-list.component.ts